import React from 'react';
import '../Media.css';
import FlipBook from '../../../components/FlipBook';

function Publications() {
  const publications = [
    {
      title: "The Exchange",
      author: "HCHS Editorial Committee",
      pdfFile: "/flipbooks/TheExchange.pdf"
    },
    {
      title: "Houston's 50 Most Influential Women of 2024",
      author: "Houston Woman Magazine",
      flowpaperUrl: "https://online.fliphtml5.com/lctmo/waly/#p=1"
    }
  ];

  return (
    <div className="media">
      <section className="page-hero">
        <h1>Digital Publications</h1>
        <p>Access our collection of historical publications and research papers</p>
      </section>

      <div className="page-container">
        <p className="publications-instructions">
          Click on miniature to enlarge to full screen, to exit press ESC
        </p>
        <div className="publications-grid">
          {publications.map((pub, index) => (
            <div key={index} className="card publication-card">
              <h3>{pub.title}</h3>
              <p className="author">by {pub.author}</p>
              <div className="publication-embed">
                {pub.pdfFile ? (
                  <div style={{ transform: 'scale(0.85)', transformOrigin: 'top center', height: '120%' }}>
                    <FlipBook pdfFile={pub.pdfFile} />
                  </div>
                ) : (
                  <iframe 
                    src={pub.flowpaperUrl}
                    title={pub.title}
                    className="flowpaper-embed"
                    frameBorder="0"
                    allowFullScreen
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Publications; 